(() => {
	const m=document.querySelector('.menu')
	document.querySelectorAll('.toggle').forEach(b=>b.onclick=()=>m.classList.toggle('open'))
})()